import { render, staticRenderFns } from "./FooterBarMenu.vue?vue&type=template&id=46a992d2&scoped=true"
import script from "./FooterBarMenu.js?vue&type=script&lang=js&external"
export * from "./FooterBarMenu.js?vue&type=script&lang=js&external"
import style0 from "./FooterBarMenu.scss?vue&type=style&index=0&id=46a992d2&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a992d2",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotButton: require('/runner/_work/app-hotmart/app-hotmart/components/Atoms/Button/Button.vue').default})
